export const enum IRADesignationListedTypes {
  NAME = 'NAME',
  RELATIONSHIP = 'RELATIONSHIP',
  EXECUTOR = 'EXECUTOR',
  TRUSTEE = 'TRUSTEE',
  NOTLISTED = 'NOTLISTED',
  NOTSURE = 'NOTSURE',
  EMPTY = '',
}
